import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, first } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { Environment, EnvironmentService } from '@galaxy/core';
import { AccountRouteParams } from '../../core/routeparams';
import { Site, SiteService } from '../../core/site';
import { Account, AccountService } from '../../core/account';

@Component({
  selector: 'app-entry',
  template: ``,
  standalone: false,
})
export class EntryComponent implements OnInit {
  private accountId: string;

  constructor(
    private router: Router,
    private siteService: SiteService,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private environmentService: EnvironmentService,
  ) {}

  ngOnInit(): void {
    this.accountId = (this.route.snapshot.params as AccountRouteParams).accountGroupId;

    // Partner (LocalEdge) SSO: a signed JWT in `token` is handed to
    // wp-cloud-manager to exchange for a session (it sets the httpOnly cookie),
    // which then redirects back here without the token to resume normally.
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      window.location.assign(this.partnerSSOExchangeUrl(token));
      return;
    }

    this.accountService.fetch(this.accountId);

    const siteResult$ = this.siteService.lookup(this.accountId);
    const accountResult$ = this.accountService.result();

    combineLatest([
      siteResult$.pipe(
        catchError(() => {
          const empty: Site = null;
          return of(empty);
        }),
      ),
      accountResult$.pipe(
        catchError(() => {
          const empty: Account = null;
          return of(empty);
        }),
      ),
    ])
      .pipe(first())
      .subscribe(([site, account]) => {
        if (site) {
          this.router.navigateByUrl('/site/' + site.siteId + '/overview');
          return;
        }
        this.router.navigateByUrl('/create-from-template/' + account.accountId);
      });
  }

  private partnerSSOExchangeUrl(token: string): string {
    const redirectTo = `${window.location.origin}/entry/${this.accountId}`;
    const params = new URLSearchParams({ token, redirect_to: redirectTo });
    return `https://${this.wpCloudManagerHost()}/wp_cloud_manager/partner-sso?${params.toString()}`;
  }

  private wpCloudManagerHost(): string {
    return this.environmentService.getEnvironment() === Environment.PROD
      ? 'wp-cloud-manager-prod.apigateway.co'
      : 'wp-cloud-manager-demo.apigateway.co';
  }
}
